import { render, staticRenderFns } from "./MedicineAnalogsTaLp.vue?vue&type=template&id=388648be&scoped=true"
import script from "./MedicineAnalogsTaLp.vue?vue&type=script&lang=js"
export * from "./MedicineAnalogsTaLp.vue?vue&type=script&lang=js"
import style0 from "./MedicineAnalogsTaLp.vue?vue&type=style&index=0&id=388648be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388648be",
  null
  
)

export default component.exports